import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api/portfolio/`;
const FRONT = process.env.FRONT_END_URL;
export const frontEnd = `${FRONT}/loginWithCode/code`;

// Login with code
const loginWithCode = async ({ email, loginCode }) => {
    try {
        const response = await axios.post(`${API_URL}loginWithCode/${email}`, { loginCode });
        return response.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        throw new Error(message);
    }
};

// Send login code
const sendLoginCode = async () => {
    const response = await axios.post(`${API_URL}sendLogicalCode`);
    return response.data.message;
};

// Logout user
const logoutUser = async () => {
    const response = await axios.get(`${API_URL}logout`);
    return response.data.message;
};

// Get login status
const getLoginStatus = async () => {
    const response = await axios.get(`${API_URL}loginStatus`);
    return response.data;
};

// Update user (modify if needed)
const updateUser = async (userData) => {
    const response = await axios.patch(`${API_URL}update-intro`, userData); // Adjust endpoint if needed
    return response.data;
};

// Add experience
const addExperience = async (experienceData) => {
    const response = await axios.post(`${API_URL}add-experience`, experienceData);
    return response.data;
};

// Update experience
const updateExperience = async (experienceData) => {
    const response = await axios.post(`${API_URL}update-experience`, experienceData);
    return response.data;
};

// Delete experience
const deleteExperience = async (experienceId) => {
    const response = await axios.post(`${API_URL}delete-experience`, { _id: experienceId });
    return response.data;
};

// Add project
const addProject = async (projectData) => {
    const response = await axios.post(`${API_URL}add-project`, projectData);
    return response.data;
};

// Update project
const updateProject = async (projectData) => {
    const response = await axios.post(`${API_URL}update-project`, projectData);
    return response.data;
};

// Delete project
const deleteProject = async (projectId) => {
    const response = await axios.post(`${API_URL}delete-project`, { _id: projectId });
    return response.data;
};

// Add certificate
const addCertificate = async (certificateData) => {
    const response = await axios.post(`${API_URL}add-certificate`, certificateData);
    return response.data;
};

// Update certificate
const updateCertificate = async (certificateData) => {
    const response = await axios.post(`${API_URL}update-certificate`, certificateData);
    return response.data;
};

// Delete certificate
const deleteCertificate = async (certificateId) => {
    const response = await axios.post(`${API_URL}delete-certificate`, { _id: certificateId });
    return response.data;
};

const authService = {
    logoutUser,
    loginWithCode,
    sendLoginCode,
    getLoginStatus,
    updateUser,
    addExperience,
    updateExperience,
    deleteExperience,
    addProject,
    updateProject,
    deleteProject,
    addCertificate,
    updateCertificate,
    deleteCertificate,
};

export default authService;
